import * as React from "react";

import { ACountry, CustomerInformation_Address_Response } from "../../Common";

import { useDeliveryDetailsUserExperience_asController } from "../providers";

export interface SavedAddressItemProps {
  addressFormType: string;

  value: CustomerInformation_Address_Response;
  currentlySelectedAddressId?: any;

  handleSelectAddress: (value: CustomerInformation_Address_Response) => void;
}
export const SavedAddressItem: React.FunctionComponent<
  SavedAddressItemProps
> = (props) => {
  const { value, currentlySelectedAddressId } = props;

  const { handleDeleteSavedAddress } =
    useDeliveryDetailsUserExperience_asController();

  const isThisAddressCurrentlySelected = React.useMemo(() => {
    return (
      currentlySelectedAddressId && value.id === currentlySelectedAddressId
    );
  }, [value, value.id, currentlySelectedAddressId]);

  const inputId = React.useMemo(() => {
    return `${props.addressFormType}--select_address--${value.id}`;
  }, [props.addressFormType, props.value, props.value.id]);

  const handleSelectAddress: React.MouseEventHandler<HTMLDivElement> =
    React.useCallback(
      (event) => {
        event.preventDefault();
        props.handleSelectAddress(value);
      },
      [value, props.handleSelectAddress]
    );

  // labels propagate clicks to inputs they're associated with,
  // which then propagates to the parent element,
  // which also catches the initial propagation from the label click,
  // causing it to be called twice.
  // so we stop the default behaviour of label's click,
  // to prevent it passing the event along to its associated input.
  const handleLabelClick: React.MouseEventHandler = (
    event: React.MouseEvent
  ) => {
    event.preventDefault();
  };

  const handleDeleteAddress: React.MouseEventHandler<HTMLButtonElement> =
    React.useCallback(
      (event) => {
        event.preventDefault();
        handleDeleteSavedAddress(props.value);
      },
      [handleDeleteSavedAddress, props.value]
    );

  return (
    <div
      className={`saved-address ${
        isThisAddressCurrentlySelected
          ? "currently-selected"
          : "not-currently-selected"
      }`}
      onClick={handleSelectAddress}
    >
      <div className="lhs">
        <input
          type="radio"
          id={inputId}
          name={inputId}
          value={value.id}
          defaultChecked={isThisAddressCurrentlySelected}
          checked={isThisAddressCurrentlySelected}
        />
        <label htmlFor={inputId} onClick={handleLabelClick}></label>
      </div>
      <div className="rhs">
        <h4 className="name">{`${value.firstname || ""} ${
          value.lastname || ""
        }`}</h4>
        <p className="address-value">
          <span className="street-1">{`${
            (value.street || ["", ""])[0] || ""
          }`}</span>
          <span className="street-2">{`${
            (value.street || ["", ""])[1]
              ? ` ${(value.street || ["", ""])[1]}`
              : ""
          },`}</span>
          <span className="city">{` ${value.city || ""},`}</span>
          <span className="region">{`${
            value.region?.region ? ` ${value.region.region}` : ""
          }`}</span>
          <span className="region_code">{`${
            value.region?.region_code ? ` ${value.region.region_code}` : ""
          }`}</span>
          <span className="postcode">{` ${value.postcode || ""}`}</span>
          <span className="country_code">{` ${
            {
              [ACountry.Australia]: "Australia",
              [ACountry.NewZealand]: "New Zealand",
            }[(value.country_code || "").toLowerCase()] || ""
          }`}</span>
        </p>
        {value.telephone && <p className="telephone">{`${value.telephone}`}</p>}
      </div>
      <div className="rhs-ultimate">
        <button
          className={`${
            props.value.default_shipping || props.value.default_billing
              ? "address-is-used-as-a-default"
              : "address-is-not-a-default"
          }`}
          onClick={handleDeleteAddress}
        >{`Delete address`}</button>
      </div>
    </div>
  );
};
